import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/1.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/10.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/11.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/12.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/13.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/14.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/15.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/2.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/3.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/4.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/5.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/6.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/7.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/8.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/home/partners/9.png");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.3.8_@babel+core@7.28.5_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react-dom@1_qju5jnn2ro242seicfecxp7w4q/node_modules/next/dist/client/image-component.js");
